/* eslint-disable */
import Tesseract from "tesseract.js";

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    if (src instanceof Blob) {
      img.src = URL.createObjectURL(src);
    } else {
      img.src = src;
    }
  });
}

async function prepareCardNumberCrop(fileOrDataUrl) {
  const img = await loadImage(fileOrDataUrl);
  const w = img.naturalWidth || img.width;
  const h = img.naturalHeight || img.height;

  const x = Math.floor(w * 0.04);
  const y = Math.floor(h * 0.18);
  const cw = Math.floor(w * 0.42);
  const ch = Math.floor(h * 0.22);

  const scale = 3;
  const canvas = document.createElement("canvas");
  canvas.width = cw * scale;
  canvas.height = ch * scale;
  const ctx = canvas.getContext("2d");

  ctx.imageSmoothingEnabled = true;
  ctx.drawImage(img, x, y, cw, ch, 0, 0, canvas.width, canvas.height);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const d = imageData.data;
  for (let i = 0; i < d.length; i += 4) {
    const g = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
    let v = (g - 128) * 1.8 + 128;
    v = Math.max(0, Math.min(255, v));
    v = v < 140 ? 0 : 255;
    d[i] = d[i + 1] = d[i + 2] = v;
  }
  ctx.putImageData(imageData, 0, 0);

  return canvas.toDataURL("image/png");
}

export async function extractIdCardData(fileOrDataUrl, onProgress) {
  const cropDataUrl = await prepareCardNumberCrop(fileOrDataUrl);

  const result = await Tesseract.recognize(cropDataUrl, "eng", {
    tessedit_pageseg_mode: "7",
    logger: (m) => {
      if (m.status === "recognizing text" && typeof onProgress === "function") {
        onProgress(Math.round((m.progress || 0) * 100));
      }
    },
  });

  const text = (result?.data?.text || "").replace(/\s+/g, " ").trim();
  const lines = (result?.data?.text || "")
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);

  const matches = text.match(/\d{7,12}/g) || [];

  const preferred =
    matches.find((m) => m.length === 9) ||
    matches.find((m) => m.length >= 8 && m.length <= 10) ||
    matches[0] ||
    null;

  return {
    rawText: text,
    lines,
    cardNumber: preferred,
    candidates: {
      fromCrop: matches,
      all: matches,
    },
    debugCropDataUrl: cropDataUrl,
  };
}
